// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-modal {
  padding-inline: 30px;
}

.delete-header {
  color: #0a0f0d;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.delete-content {
  color: #5b5e5d;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.6px;
}

.cancel-delete-btn {
  margin-right: 20px;
  border-radius: 5px;
  background: #e0e0e0;
  border: none;
  display: flex;
  height: 40px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.delete-modal
  .btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
  background: fixed;
}

.cancel-btn-text {
  color: #0a0f0d;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.delete-btn-text {
  color: #fff;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.cancel-delete-btn:hover {
  background: #e0e0e0 !important;
}

.yes-delete-btn {
  border: none;
  border-radius: 5px;
  background: #d2042d;
  display: inline-flex;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.delete-campaign-cancel-button {
  padding-top: 25px;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/delete-campaign/DeleteCampaign.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX","sourcesContent":[".delete-modal {\n  padding-inline: 30px;\n}\n\n.delete-header {\n  color: #0a0f0d;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.delete-content {\n  color: #5b5e5d;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20.6px;\n}\n\n.cancel-delete-btn {\n  margin-right: 20px;\n  border-radius: 5px;\n  background: #e0e0e0;\n  border: none;\n  display: flex;\n  height: 40px;\n  padding: 8px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.delete-modal\n  .btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n  background: fixed;\n}\n\n.cancel-btn-text {\n  color: #0a0f0d;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.delete-btn-text {\n  color: #fff;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.cancel-delete-btn:hover {\n  background: #e0e0e0 !important;\n}\n\n.yes-delete-btn {\n  border: none;\n  border-radius: 5px;\n  background: #d2042d;\n  display: inline-flex;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.delete-campaign-cancel-button {\n  padding-top: 25px;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
